export const addIcon = require("Assets/Images/add.svg");
export const plusIcon = require("Assets/Images/plus.svg");
export const editIcon = require("Assets/Images/edit.svg");
export const closedIcon = require("Assets/Images/closed.svg");
export const completeIcon = require("Assets/Images/complete.svg");
export const trashIcon = require("Assets/Images/trash.svg");
export const topIcon = require("Assets/Images/top.svg");
export const blackArrowIcon = require("Assets/Images/black-arrow.svg");
export const circleArrowIcon = require("Assets/Images/circle-arrow-button.svg");
